import React, { FunctionComponent } from 'react';
import Chat from "@murphy-frontend/web-core/assets/icons/chat.svg";
import Msg from "@murphy-frontend/web-core/assets/icons/msg.svg";

interface MBSTemplateProps {
  id: number,
  title: string,
  description: string,
  replyRequired: boolean,
  selected: boolean,
  flashing?: boolean,
  templateType?: 'custom' | 'default',
  onSelectTemplate?: (templateId: string) => void,
  onSelectCustomTemplate?: (templateId: string) => void
}

const MBSTemplate: FunctionComponent<MBSTemplateProps> = ({
  id,
  title,
  description,
  replyRequired,
  selected,
  flashing,
  templateType = 'default',
  onSelectTemplate,
  onSelectCustomTemplate
}) => {
  let classes = selected ? 'template-wrapper selected' : 'template-wrapper';

  if (flashing) {
    classes += ' zoom-in-zoom-out-animation';
  }

  const handleClick = () => {
    console.log("Clicked:", id, "Selected:", selected);

    const isCustom = templateType === 'custom';

    const actualId = typeof id === 'string' && id.includes('-')
      ? parseInt(id.toString().split('-')[1])
      : id;

    console.log("Extracted numeric ID:", actualId);

    if (isCustom && onSelectCustomTemplate) {
      onSelectCustomTemplate(actualId);
    } else if (onSelectTemplate) {
      onSelectTemplate(actualId);
    }
  };

  return (
    <div className={classes} onClick={handleClick}>
      {replyRequired ? <Chat /> : <Msg />}
      <div style={{ marginLeft: 20, flexDirection: 'column', display: 'flex' }}>
        <label className={selected ? 'template-text title selected' : 'template-text title'}>
          {title}
        </label>
        <label className='template-text'>{description}</label>
      </div>
    </div>
  );
};

export default MBSTemplate;